import { APIPost, APIPut } from "api/protocols";
const apiVersion = "2024-04";
const baseCustomerUrl = "/" + apiVersion + "/customer";

interface IPostBookingParams {
  tee_time_id: number;
  holes: number;
  quantity: number;
  power_cart_quantity: number;
  customer_payment_method_id?: number | null;
  accept_payment_terms: boolean;
  accept_marketing_email?: boolean;
  cart_token?: string;
  order_id?: number;
  booking_fee_order_id?: number;
  lock_quantity?: boolean;
  lock_holes?: boolean;
  lock_power_cart_quantity?: boolean;
  customer_ids: Array<number>;
  customers_riding?: boolean[];
  waitlist_reference_id?: string;
  customer_names?: Array<string>;
  deposit_id?: number;
  source?: string;
  pre_paid?: boolean;
  booking_group_id?: string;
}

interface IPutValidateBookingParams {
  tee_time_id: number;
  holes: number;
  quantity: number;
  power_cart_quantity: number;
  customer_payment_method_id: number;
  accept_payment_terms: boolean;
  customer_ids: Array<number>;
  customers_riding?: boolean[];
  customer_names?: Array<string>;
}

interface IPostBookingNote {
  tee_time_booking_id: number;
  content: string;
  tee_time_booking_participant_id?: number;
}

export async function PostCustomerBooking(params: IPostBookingParams, useGlobalLoader: boolean) {
  return await APIPost(baseCustomerUrl + "/tee-time/booking", params, useGlobalLoader);
}

export async function PutValidateCustomerBooking(params: IPutValidateBookingParams, useGlobalLoader: boolean) {
  return await APIPut(baseCustomerUrl + "/tee-time/booking/validate", params, useGlobalLoader);
}


export async function PostCustomerBookingNote(params: IPostBookingNote, useGlobalLoader: boolean) {
  return await APIPost(baseCustomerUrl + "/tee-time/booking/note", params, useGlobalLoader);
}